import React from 'react';
import Marked from 'marked';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';

import MainPageComponent from '../_generic/main.page.component';

import { documents } from '../../docs/documents';

const styles = theme => ({
  menu: {
    height: '100vh',
    float: 'left',
    marginRight: '20px',
  },
  doc: {
    display: 'inline-block',
    width: '100%',
  },
  content: {
    padding: '40px',
  },
  left: {
    float: 'left',
  },
  title: {
    padding: '20px 20px',
  },
});

class DocsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      activeTab: 'Rules',
      markdown: '',
    };
  }

  componentDidMount() {
    fetch(documents.get(this.state.activeTab).path)
      .then(response => response.text())
      .then(text => this.setState({ markdown: Marked(text) }));
  }

  handleChange(activeTab) {
    this.setState({ activeTab });
    if (documents.has(activeTab)) {
      fetch(documents.get(activeTab).path)
        .then(response => response.text())
        .then(text => this.setState({ markdown: Marked(text) }));
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <MainPageComponent>
        <Grid container spacing={24}>
          <Grid item xs={2} className={classes.left}>
            <MenuList className={classes.menu} >
              <Typography className={classes.title} variant="h4">Help</Typography>
              {this.renderItems()}
            </MenuList>
          </Grid>
          <Grid item xs={10} className={classes.left}>
            <div className={classes.doc} >
              <Paper className={classes.content}>
                <Typography dangerouslySetInnerHTML={{ __html: this.state.markdown }} className='markdown'/>
              </Paper>
            </div>
          </Grid>
        </Grid>
      </MainPageComponent>
    );
  }

  renderItems() {
    const { classes } = this.props;
    const { activeTab } = this.state;
    return Array.from(documents, ([key, value]) => (
      <MenuItem onClick={() => this.handleChange(key)} className={classes.menuItem} selected={activeTab === key}>
        <ListItemIcon className={classes.icon}><Icon>{value.icon}</Icon></ListItemIcon>
        <ListItemText classes={{ primary: classes.primary }} inset primary={key} />
      </MenuItem>
    ));
  }
}

DocsComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DocsComponent);
